import { Text } from '~/components/ui/Text';
import { DialogueReplyIcon } from '~/shared';
import { buttonIcons } from './Button.model';
import { StyledButton, StyledIcon } from './Button.styled';

const Button = ({
	text,
	type,
	onClick,
	span,
	...props
}: {
	text: string;
	type: DialogueReplyIcon;
	onClick?: () => void;
	span?: number;
} & React.HTMLAttributes<HTMLDivElement>) => {
	return (
		<StyledButton $type={type} $span={span} onClick={onClick} {...props}>
			<Text>{text}</Text>
			{buttonIcons[type] && (
				<StyledIcon $type={type} $icon={buttonIcons[type]} />
			)}
		</StyledButton>
	);
};

export { Button };
